import * as APPCONFIG from "../../src/config/app-config";
import api from "./BaseAPI.js";
import Http from "./Http.js";

export const getLogin = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/login`,
    data: JSON.stringify(formValues),
  });
};

export const sendResetPasswordEmail = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/sendResetPasswordEmail`,
    data: JSON.stringify(formValues),
  });
};

export const verifyEmail = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/verifyEmail`,
    data: JSON.stringify(formValues),
  });
};

export const changePassword = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/changePassword`,
    data: JSON.stringify(formValues),
  });
};

export const sendlocation = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/sendlocation`,
    data: JSON.stringify(formValues),
  });
};

export const signin = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/signin`,
    data: formValues,
    headers: Http.MULTIPART_HEADERS()
  });
};

export const getAddress = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/getAddress`,
    data: JSON.stringify(formValues),
  });
};

export const getCoordinates = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/getCoordinates`,
    data: JSON.stringify(formValues),
  });
};


export const requestAppointment = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/requestAppointment`,
    data: JSON.stringify(formValues),
  });
};




